// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__AHpYz","col":"styles_col__1pb2-","fulfillmentStatus":"styles_fulfillmentStatus__1YZ9k","emailCol":"styles_emailCol__2eltO"};